export enum FTFIND_EVENT {
  MERGE = "ftfind.history.merge",
  PUSH = "ftfind.history.push",
  SHIFT = "ftfind.history.shift",
  DRESON_RESOLVED = "ftfind.dresonRule.resolved",
}
